export const datatable = {
  page: 'Page',
  outOf: 'of',
  countSize: 'Records per page',
  showing: 'Showing',
  showingCont: 'records of',
  choose: 'Choose',
  notFoundField: 'Field not found',
  searchPlaceholder: 'Find step',
}
